import { Dispatch } from 'redux'

export const CLEAR_DOCUMENTS = 'CLEAR_DOCUMENTS'

export const clearDocuments = (dispatch: Dispatch) => {
  dispatch({ type: CLEAR_DOCUMENTS })
}
